export default "__VITE_ASSET__BnNDWgvY__"